import { Skeleton } from '@mui/material';
import { StatusList, StatusListItem } from './alerts-tasks.styles';

export const AlertsTasksSkeleton = () => {
  return (
    <StatusList>
      <StatusListItem>
        <Skeleton variant="text" width={200} />
      </StatusListItem>
      <StatusListItem>
        <Skeleton variant="text" width={200} />
        <Skeleton variant="rectangular" width={100} height={20} sx={{ marginTop: '6px', display: 'flex' }} />
      </StatusListItem>
    </StatusList>
  );
};
